module.exports = __webpack_public_path__ + "img/8-full-md.e125772c.jpg";